import type { FaireProductEntity } from "../../entity_types/product";

export const p_40544209w3: FaireProductEntity = {
  token: "p_40544209w3",
  type: "product",
  name: "Magnet VA-465 Franklin Street, Richmond",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bcd180aa34200160e675cd4e930950efdd7969cacf3a8ea487466befb10043e4.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a9f09647e881634b90ef39ace60172d0699c3d5b4e45454a2e9f4981d9f9c454.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
